import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postUpdateGiveawayStock = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `/productivity-host/briefs/giveaways/histories`,
    data: payload,
  });

  return data?.data;
};

export default postUpdateGiveawayStock;
